// Shared low-level helpers used by compiler modules.
// They are intentionally stateless and pure.
// Pre-compiled regex patterns for brace counting (avoid per-call allocation).
const OPEN_BRACE_REGEX = /\{/g
const CLOSE_BRACE_REGEX = /\}/g

// Count occurrences of a specific token character in one line.
export function countToken(line: string, token: "{" | "}"): number {
  // Regex returns all '{' or '}' matches so their count can be tracked.
  const regex = token === "{" ? OPEN_BRACE_REGEX : CLOSE_BRACE_REGEX
  regex.lastIndex = 0
  const matches = line.match(regex);
  return matches ? matches.length : 0;
}

// Escape a string for safe use inside RegExp constructors.
export function escapeRegExp(input: string): string {
  // Regex matches special RegExp characters and escapes each one.
  return input.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

// Guarantee declaration output ends with a semicolon.
export function ensureSemicolon(declaration: string): string {
  const trimmed = declaration.trim()
  return trimmed.endsWith(";") ? trimmed : `${trimmed};`;
}

// Normalize rendered declaration spacing to `property: value;`.
export function formatRenderedDeclaration(declaration: string): string {
  const trimmed = declaration.trim()
  const separator = trimmed.indexOf(':')
  if (separator === -1) {
    return ensureSemicolon(trimmed)
  }

  const property = trimmed.slice(0, separator).trimEnd()
  const value = trimmed.slice(separator + 1).trim()
  const normalized = value.length > 0 ? `${property}: ${value}` : `${property}:`
  return ensureSemicolon(normalized)
}

// Indent multiline text blocks for readable wrapped output.
export function indent(content: string, spaces = 2): string {
  const prefix = " ".repeat(spaces);
  return content
    .split("\n")
    .map((line) => `${prefix}${line}`)
    .join("\n");
}
